import { Injectable, OnDestroy } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { DialogCloseOverlayComponent } from './dialog-close-overlay/dialog-close-overlay.component';
import { DialogManagerService } from './dialog-manager.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class FloatingDialogControlsService implements OnDestroy {
    private overlayRef?: OverlayRef;
    private componentAttached = false;

    constructor(
        private overlay: Overlay,
        private dialogManager: DialogManagerService,
        private matDialog: MatDialog
    ) {
        this.matDialog.afterOpened.subscribe(() => this.toggleOverlay(true));
        this.matDialog.afterAllClosed.subscribe(() => this.toggleOverlay(false));
    }

    init(): void {
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create({
                positionStrategy: this.overlay.position().global().top('12px').right('64px'),
                hasBackdrop: false,

                panelClass: 'floating-dialog-controls-overlay',
                scrollStrategy: this.overlay.scrollStrategies.reposition()
            });
            this.overlayRef.hostElement.style.zIndex = '2147483647'; // Ensure the overlay is on top of all other elements
            
        }

        this.toggleOverlay(this.matDialog.openDialogs.length > 0);
    }

    ngOnDestroy(): void {
        this.overlayRef?.dispose();
    }

    private toggleOverlay(show: boolean): void {
        if (!this.overlayRef) {
            return;
        }

        if (show && !this.componentAttached) {
            const componentRef = this.overlayRef.attach(new ComponentPortal(DialogCloseOverlayComponent));
            componentRef.instance.close.subscribe(() => this.dialogManager.confirmCloseTopDialog());
            this.componentAttached = true;
        } else if (!show && this.componentAttached) {
            this.overlayRef.detach();
            this.componentAttached = false;
        }
    }
}
